
import { React, useEffect, useState, useRef } from 'react'
import { motion } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import { Toast } from 'primereact/toast';
import PortalComponents from '../../components/PortalComponents/PortalComponents';
import { Button } from "@nextui-org/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../CustomerPortal.css';
import DropFileInput from '../../components/DragAndDrop/components/drop-file-input/DropFileInput';
import axios from 'axios';
import BackEndUrl from '../../backURL';
import { Message } from 'primereact/message';
import { Checkmark } from 'react-checkmark'
import loading from '../../Images/three-dots.svg'

const backend = BackEndUrl.domain
const desiredTimezone = 'Asia/Colombo';
const ContactChange = ({ formik, policy_number, verified, setVerified, countdown, Setcountdown }) => {

  const toast = useRef(null);
  async function CheckForOTP() {

    try {

      const response = await axios.post(backend + "/contact-change-otp-check", {

        nic: sessionStorage.getItem('nic'),
        mobile: sessionStorage.getItem('mobile'),
        policy_number: policy_number,

      }, {
        headers: {
          Authorization: sessionStorage.getItem('token'),
        }
      });
      return response.data



    }
    catch (err) {
      console.log(err)

    }

  }
  useEffect(() => {
    async function CheckForAssignedOTP() {
      const existingValidOtp = await CheckForOTP();
      if (existingValidOtp.length != 0) {
        setOtp(existingValidOtp[0].otp)
        const otpSentTime = new Date(existingValidOtp[0].otp_sent_time);
        const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
        const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));

       
      
        Setcountdown(timeDifferenceInMinutes)
        setIsLoaded(true)
        setotpLoaded(true)
        countingDown()
      } else {
        setIsLoaded(true)
      }

    }
    if (!otp && !countdown) {
      CheckForAssignedOTP()

    }
  },[]);



  const [otp, setOtp] = useState(null);
  const [userOtp, setuserOtp] = useState(null);
  const [otpLoaded, setotpLoaded] = useState(false);
  const [otpError, setOptError] = useState(null);
  const countDownInterval = useRef(null);
  const [isLoaded, setIsLoaded] = useState(false)


  function ValidateContactNumber() {
    const currentVal = formik.values.policy_mobile.newMobile;
   
    if (!currentVal ) {
   
      formik.errors.policy_mobile = "*Required";
    } else {

      if (currentVal && currentVal.length != 10) {

        formik.errors.policy_mobile = "Invalid Contact Number";
      }
      else{
    
        if (formik.values.policy_mobile.oldMobile == currentVal) {

          formik.errors.policy_mobile = "The number already exits";
        } else {
          delete formik.errors.policy_mobile
        }
      }
        


    }
  }
  useEffect(() => {

    ValidateContactNumber()
  }, [formik.values.policy_mobile.newMobile])

  
  
  function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
  }
  function VerifyOTP() {
    if (userOtp) {
      if (otp == userOtp) {
        setVerified(true)
        setOptError(null)
      }
      else {
        setOptError("Invalid OTP")
      }

    } else {
      setOptError("*Required")
    }



  }
  function countingDown() {

    if (countDownInterval.current) {
      clearInterval(countDownInterval.current);
    }
    countDownInterval.current = setInterval(() => {
      Setcountdown(prevCountdown => {
        if (prevCountdown > 0) {
          return prevCountdown - 1;
        } else {
          clearInterval(countDownInterval.current);
          setOtp(null)
          return 0;
        }
      });
    }, 1000);

  }

  async function sendOtp() {

    try {

      const response = await axios.post(backend + "/contact-change-otp", {
        newContact: formik.values.policy_mobile && formik.values.policy_mobile.newMobile,
        nic: sessionStorage.getItem('nic'),
        mobile: sessionStorage.getItem('mobile'),
        policy_number: policy_number,

      }, {
        headers: {
          Authorization: sessionStorage.getItem('token'),
        }
      });
      
      return (response.data)



    }
    catch (err) {
      console.log(err)

    }
  }


  async function OnclickSendOTP() {
    ValidateContactNumber();
    formik.validateForm().then(async (errors) => {


      if (errors.policy_mobile === undefined) {

        const existingValidOtp = await CheckForOTP();
        if (existingValidOtp.length == 0) {
          const newOtp = await sendOtp()

          setOtp(newOtp.otp)
          setotpLoaded(true)
          const otpSentTime = new Date(newOtp.otp_sent_time);
          const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
         const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));

          Setcountdown(timeDifferenceInMinutes)
          countingDown()
        }
        else {

          setOtp(existingValidOtp[0].otp)
          setotpLoaded(true)
          const otpSentTime = new Date(existingValidOtp[0].otp_sent_time);
          const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
          const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));


          Setcountdown(timeDifferenceInMinutes)
          countingDown()
        }

      } else {
        toast.current.clear();
        toast.current.show({
          severity: 'error',
          summary: 'Invalid or missing Information',

          life: 3000,
          sticky: false,
          content: (props) => (
            <div className="p-3" style={{ flex: '1' }}>
              <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
              <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
            </div>
          ),
        });
      }


    });
  }
  return (
    <div className='d-flex justify-content-center align-items-center flex-column'>
      <Toast ref={toast} position="top-center" />

      {isLoaded ? <>

        <Col xs={12} className='pt-5  mt-5 d-flex justify-content-center' >
          <Row style={{ width: "75%" }}>

            <Col xs={12} >

              <Row>
                <Col xs={10}> <PortalComponents
                  type={"input-number"}
                  label={"New Contact Number"}
                  formik={formik}
                  name={`policy_mobile[newMobile]`}
                  value={formik.values.policy_mobile && formik.values.policy_mobile.newMobile}
                  onchange={formik.handleChange}
                  errors={formik.errors.policy_mobile}
                  isDisabled={countdown > 0 ? true : false}



                /></Col>
                <Col xs={2} className='d-flex align-items-center'>
                  <Button style={{ backgroundColor: "#2EB9EE", color: "white" }} onClick={() => { OnclickSendOTP() }} isDisabled={countdown > 0 ? true : false} >  Send OTP</Button>
                </Col>
              </Row>
            </Col>
          </Row>


        </Col>

        {otpLoaded && !verified &&
          <Row className='d-flex justify-content-center'>
            <Col xs={12} style={{ textAlign: "" }} className='my-3'>
              {countdown > 0 ?
                <div className='d-flex flex-row align-items-center' >
                  <p>Time Remaining </p> <small className='ms-3'>{formatTime(countdown)}</small>
                </div>

                :

                <Message severity="error" style={{ textAlign: "center" }} text=" OTP expired" />

              }
            </Col>

          </Row>}
        <Row style={{ width: "75%" }} className='d-flex align-items-center flex-row justify-content-center'>
          <Col xs={9} className='d-flex align-items-center flex-row justify-content-center'>
            <PortalComponents
              type={"input"}
              label={"Enter The OTP"}
              isDisabled={!formik.values.policy_mobile.newMobile ? true : false}
              formik={formik}
              name={"otp-input"}
              value={userOtp}
              onchange={(e) => { setuserOtp(e.target.value) }}
              errors={otpError}

            />


          </Col>
          <Col xs={3} className='d-flex align-items-center '>
            <Button style={{ backgroundColor: "#198754", color: "white", height: "7vh" }} className=' mx-2' onClick={() => { VerifyOTP() }} isDisabled={!formik.values.policy_mobile.newMobile > 0 ? true : false}
            >


              {verified ?
                <Checkmark size='256px' color='#198754' />
                :
                <>Verify</>}
            </Button>
          </Col>

        </Row>
      </> :
        <Row>
          <img src={loading} className='m-5' style={{ width: "40%" }} />
        </Row>

      }
    </div>
  )
}

export default ContactChange
